import classNames from 'classnames';
import { parseISO } from 'date-fns/parseISO';
import { FormattedDate } from 'react-intl';

import styles from '../../styles/partials/date.module.css';

interface DateProps {
    date?: string | null;
    day?: 'numeric' | '2-digit';
    withoutDay?: boolean;
    className?: string | null;
    [key: string]: unknown;
}

function Date({
    date = null,
    day = 'numeric',
    withoutDay = false,
    className = null,
    ...props
}: DateProps) {
    const dateObj = date !== null ? parseISO(date) : null;
    return date !== null ? (
        <div className={classNames([styles.container, className])}>
            <FormattedDate
                day={!withoutDay ? day : undefined}
                // weekday="short"
                month="long"
                year="numeric"
                value={dateObj}
                {...props}
            />
        </div>
    ) : null;
}

export default Date;
